import { ABTestingMatrix } from "./ab-testing-matrix";
import { useABTestingSWR } from "./use-ab-testing-swr";

export function useABTesting(): ABTestingMatrix {
  const { data } = useABTestingSWR();
  return data ?? {};
}
